import { SignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const Login = () => {
  return (
    <div className='w-full bg-content text-content-text'>
      <div className='w-full min-h-[calc(100svh-80px)] bg-no-repeat bg-cover bg-center bg-hero bg-content text-content-text flex items-center justify-center'>
        <div className='container flex flex-col gap-8 justify-center items-center px-4 py-8 sm:px-8 sm:py-12 mx-auto w-full'>
          <SignedIn>
            <RedirectToHome />
          </SignedIn>
          <SignedOut>
            <SignIn forceRedirectUrl='/' />
          </SignedOut>
        </div>
      </div>
    </div>
  );
};

// Separate component to handle redirect after sign in
const RedirectToHome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  return null;
};
